import { Component, OnInit, Input } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

import { StatusBarModel } from './status-bar.model';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss']
})
export class StatusBarComponent implements OnInit {

  @Input() data: Array<StatusBarModel>;
  @Input() leftLabel: string;
  @Input() rightLabel: string;
  totalValue = 0;
  dataSeperatorWidth = '1px';
  ariaLabel: string;
  constructor() { }

  ngOnInit() {
    this.data.forEach((d) => {
      this.totalValue += d.value;
      if(d.ariaLabel ) {
          this.ariaLabel = d.ariaLabel;
      }
    });
    if (!this.rightLabel) {
      this.rightLabel = String(this.totalValue);
    }
  }

  calcProgress(d, index) {
    let marginLeft = 0;
    let styles: any;

    const width = Number((d.value / this.totalValue) * 100);

    // Calculate all Preceeding Values ranges
    for (let i = 0; i < index; i++) {
      marginLeft = marginLeft + Number((this.data[i].value / this.totalValue) * 100);
    }

    const barWidth = 'calc(' + width + '% - ' + this.dataSeperatorWidth + ')';
    const barPosition = 'calc(' + marginLeft + '% + ' + this.dataSeperatorWidth + ')';

    styles = {
      'background-color': d.color,
      'width': barWidth,
      'margin-left': barPosition
    };
    return styles;
  }

}
